import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import FlexBox from '../../../../components/FlexBox/index';

export default function ModalError(props) {
  return (
    <Modal
      style={{
        overlay: {
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.75)',
          alignItems: 'center',
          justifyContent: 'center',
          display: 'flex',
        },
        content: {
          position: 'relative',
          border: 'none',
          background: 'red',
          overflow: 'auto',
          WebkitOverflowScrolling: 'touch',
          borderRadius: '4px',
          outline: 'none',
          padding: '20px',
        },
      }}
      ariaHideApp={false}
      isOpen={props.isOpen}
      aria={{
        labelledby: 'heading',
        describedby: 'full_description',
      }}
    >
      <div id="full_description">
        <ul>
          {props.data.length > 0 &&
            props.data.map((obj, idx) => (
              <li style={{ color: 'white' }} key={idx}>
                {obj.message}
              </li>
            ))}
        </ul>
      </div>
      <FlexBox justifyContent="center">
        <button
          style={{
            borderWidth: 1,
            borderStyle: 'solid',
            borderColor: '#fff',
            borderRadius: 3,
            padding: 7,
            paddingLeft: 20,
            paddingRight: 20,
            color: '#fff',
            cursor: 'pointer',
          }}
          onClick={props.toggleModalError}
        >
          Close
        </button>
      </FlexBox>
    </Modal>
  );
}
ModalError.propTypes = {
  isOpen: PropTypes.bool,
  data: PropTypes.array,
  toggleModalError: PropTypes.func,
};



// WEBPACK FOOTER //
// ./app/containers/Login/components/ModalErrors/index.js